import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Button, Stack } from "@mui/material";
import StructureCanvas from "./StructureCanvas";
import PreviewCanvas from "./PreviewCanvas";
import { useNewsletterEditor } from "../context/NewsletterEditorContext";
import { EDITOR_ACCENT } from "../editorUiConstants";

const VIEW_CANVAS = "canvas";
const VIEW_PREVIEW = "preview";

const viewButtonSx = (active) => ({
  borderRadius: 0,
  minWidth: 128,
  fontWeight: 700,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  ...(active
    ? {
        bgcolor: EDITOR_ACCENT,
        color: "#fff",
        "&:hover": { bgcolor: EDITOR_ACCENT, opacity: 0.92 },
      }
    : {
        borderColor: EDITOR_ACCENT,
        color: EDITOR_ACCENT,
      }),
});

const CanvasPanel = ({ onCompile }) => {
  const [viewMode, setViewMode] = useState(VIEW_CANVAS);
  const { document } = useNewsletterEditor();

  return (
    <Box
      sx={{
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {viewMode === VIEW_CANVAS ? (
          <StructureCanvas />
        ) : (
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "auto",
              p: 1,
              backgroundColor: "#f8fafc",
            }}
          >
            <PreviewCanvas document={document} onCompile={onCompile} fillHeight />
          </Box>
        )}
      </Box>

      <Box sx={{ p: 1, borderTop: "1px solid #e2e8f0", flexShrink: 0 }}>
        <Stack direction="row" spacing={1} justifyContent="center">
          <Button
            variant={viewMode === VIEW_CANVAS ? "contained" : "outlined"}
            size="small"
            sx={viewButtonSx(viewMode === VIEW_CANVAS)}
            onClick={() => setViewMode(VIEW_CANVAS)}
          >
            Canvas
          </Button>
          <Button
            variant={viewMode === VIEW_PREVIEW ? "contained" : "outlined"}
            size="small"
            sx={viewButtonSx(viewMode === VIEW_PREVIEW)}
            onClick={() => setViewMode(VIEW_PREVIEW)}
          >
            Anteprima
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

CanvasPanel.propTypes = {
  onCompile: PropTypes.func.isRequired,
};

export default CanvasPanel;
 